import { action, makeObservable, observable } from 'mobx';
import WizardSteps from 'pages/FieldCalibration/components/Wizard/WizardSteps';

export default class WizardStore {
  @observable currentStep: WizardSteps;

  constructor() {
    this.currentStep = WizardSteps.Introduction;
    makeObservable(this);
  }

  @action previous = (): void => {
    if (this.currentStep > WizardSteps.Introduction) this.currentStep -= 1;
  };

  @action next = (): void => {
    if (this.currentStep < WizardSteps.DataCapture) this.currentStep += 1;
  };

  @action reset = (): void => {
    this.currentStep = WizardSteps.Introduction;
  };

  @action goToDataCapture = (): void => {
    this.currentStep = WizardSteps.DataCapture;
  };
}
